// extracted by mini-css-extract-plugin
export default {"toggle-switch":"switch_toggle-switch__U-dF6","switch":"switch_switch__9ZbvS"};